/**
 * The signed-in user's own telephony (LMT calls plan §5.7, §5.8): `GET /api/v1/telephony/me`. Shared, because the
 * "Call" button sits in many features (customers, sales, call back) that must not import each other.
 */

import { useQuery } from '@tanstack/react-query';

import type { UseQueryResult } from '@tanstack/react-query';

import { apiClient } from '@/shared/api/client';

export interface TelephonyMe {
  enabled: boolean;
  employee: { zpContactId: string; name: string; number: string | null } | null;
  canDial: boolean;
  screenPopAvailable: boolean;
  screenPop: boolean;
}

export const telephonyMeKey = ['telephony', 'me'] as const;

export function useTelephonyMe(): UseQueryResult<TelephonyMe> {
  return useQuery({
    queryKey: telephonyMeKey,
    queryFn: async () => (await apiClient.get<TelephonyMe>('/telephony/me')).data,
    staleTime: 5 * 60_000,
    meta: { suppressGlobalError: true },
  });
}
